export default "__VITE_ASSET__CXcm66Yf__"